<template>
  <v-bottom-sheet
      v-model="sheet"
      scrollable
      persistent
      no-click-animation
      :overlay-opacity="0.7"
      content-class="bottom-sheet"
  >
    <v-card>
      <SheetHeader :title="'녹음하기'" @sheetClose="sheetClose"/>
      <v-overlay absolute :value="isLoading">
        <v-progress-circular
            indeterminate
            size="24"
        />
      </v-overlay>
      <v-card-text class="sheet-body">
        <v-progress-circular
            :rotate="-90"
            :size="158"
            :width="5"
            :value="value"
            color="#BEB7FA"
        >
          <span class="time">{{ resTimeData }}</span>
        </v-progress-circular>
        <div class="fs-16 primary--text mt-9">버튼을 누르고 녹음을 시작하세요!</div>
      </v-card-text>
      <v-card-actions>
        <div class="btn-group">
          <v-btn
              x-large depressed
              :color="recording ? '' : 'primary'"
              :class="recording ? '' : 'btn-prev'"
              class="flex-grow-1"
              @click="recordingStatus"
          >
            {{ status }}
          </v-btn>
          <v-btn
              x-large depressed
              color="primary"
              class="btn-submit"
              :disabled="!save"
              @click="recordFileSave"
          >
            <!-- @click="$emit('recordingSave')" -->
            저장
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-bottom-sheet>
</template>

<script>
import SheetHeader from "./SheetHeader";
import utils from '../../../utils/utils.js'

export default {
  props: {
    sheet: Boolean,
    beForeVoiceNote: Number,
  },
  data: () => ({
    interval: {},
    value: 0,
    recording: false,
    save: false,

    min: 0,
    sec: 0,
    timeCounter: 0,
    resTimeData: '',

    fileId: '',
    beforeFileId: '',
    fileName: '',

    isLoading: false
  }),
  components: {
    SheetHeader
  },
  computed: {
    status() {
      return (this.recording) ? '중지' : '녹음';
    }
  },
  mounted() {
    this.beforeFileId = this.beForeVoiceNote
    this.resTimeData = this.prettyTime()
  },
  methods: {
    recordingStatus() {
      this.recording = !this.recording

      if (this.recording && this.resTimeData == "00:00") {
        this.recordingStart()

      } else if (this.recording && this.resTimeData != "00:00") {
        this.save = false
        this.timeCounter = 0
        this.resTimeData = this.prettyTime()
        this.recordingStart()

      } else {
        this.recordingStop()
      }

    },
    start() {
      // 1초에 한번씩 start 호출
      this.polling = setInterval(() => {
        this.timeCounter++ //1 감소
        this.resTimeData = this.prettyTime()
      }, 1000)
    },
    // 시간 형식으로 변환 리턴
    prettyTime() {
      let time = this.timeCounter / 60
      let minutes = parseInt(time)
      let secondes = Math.round((time - minutes) * 60)
      return this.pad(minutes, 2) + ":" + this.pad(secondes, 2)
    },
    // 2자리수로 만들어줌 09,08...
    pad(n, width) {
      n = n + '';
      return n.length >= width ? n : new Array(width - n.length + 1).join('0') + n
    },
    timeStop() {
      clearInterval(this.polling)
    },
    async recordingStart() {

      utils.Record.startRecording().then(response => {

        console.log("response : ", response)

        if (response == "start") {
          this.start()
        }
      })
        .catch(async error => {
          console.log(error)
        })
        .finally(() => {
        })
    },
    async recordingStop() {

      this.timeStop()

      utils.Record.stopRecording().then(response => {
        if (response == "end") {
          this.recording = false
          this.save = true
        }
      })
        .catch(async error => {
          console.log(error)
        })
        .finally(() => {
        })
    },
    async recordFileSave() {
      this.isLoading = true

      utils.Record.saveRecordFile(this.beforeFileId).then(response => {

        this.fileId = response.data.fileId
        this.beforeFileId = response.data.fileId
        this.fileName = response.data.fileName

        this.timeCounter = 0
        this.resTimeData = this.prettyTime()
        this.recording = false
        this.save = false

        this.$emit('recordingSave', this.fileId, this.beforeFileId, this.fileName)

      })
        .catch(async error => {
          console.log(error)
          this.$emit('recordingSave', 'error', 'error')
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    sheetClose() {

      this.recordingStop()

      this.timeCounter = 0
      this.resTimeData = this.prettyTime()
      this.recording = false
      this.save = false

      this.$emit('sheetClose')

    }
  }

}
</script>

<style lang="scss" scoped>
::v-deep .v-dialog {
  .sheet-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 0 20px 0;

    .v-progress-circular {
      .v-progress-circular__underlay {
        stroke: rgba(230, 232, 234, 0.41);
      }

      .time {
        font-size: 40px;
        color: #000;
      }
    }

  }
}
</style>
